const _1KB = 1024;
const _1MB = 1024 * _1KB;

export const DocSize = ({ size }) => {
  if (size < _1KB) return `${size} bytes`;
  if (size < _1MB) return `${(size / _1KB).toFixed()} KB`;

  return `${(size / _1MB).toFixed(1)} MB`;
};
